// extracted by mini-css-extract-plugin
export default {"box":"search_box__hLi6F","btn":"search_btn__SJ+Lp","input":"search_input__co46Z","label":"search_label__vKP90","headermenu":"search_headermenu__FdzDT"};